import { getCultureOverride } from './getCultureOverride';
import { UserBootStrings, UserBootSettings } from 'owa-config';

export default function initializeLocales(
    userBootStrings: UserBootStrings,
    initializeLocalization: (culture: string, bootStrings: Record<string, string>) => Promise<void>,
    bootSettings?: UserBootSettings
) {
    // If userBootStrings is null it means we're in the owa-start boot path, in which case we've
    // already intialized localization and these parameters will be ignored.
    // TODO: Clean this up once we're fully on the new startup flow (51567)
    userBootStrings = userBootStrings || ({} as UserBootStrings);
    let culture = getCultureOverride() || bootSettings?.language || userBootStrings.language;
    return initializeLocalization(culture, userBootStrings.bootStrings);
}
